import React, { useState, useEffect } from 'react';

import { Container, Star } from './styles';

interface Props {
  value: number;
  count: number;
}

interface StarsProps {
  active: boolean;
}

const HotelsStars = ({ value, count }: Props) => {
  const [stars, setStars] = useState<StarsProps[]>([]);

  useEffect(() => {
    const starsList: StarsProps[] = [];
    for (let i = 0; i < count; i += 1) {
      starsList.push({
        active: i <= value - 1,
      });
    }
    setStars(starsList);
  }, [count, value]);

  return (
    <Container data-testid="stars">
      {stars.map((star, i) => {
        const status = star.active ? 'active' : 'disabled';
        return <Star key={i.toString()} data-testid={`${status}`} src={`/corporate/images/${status}-star.svg`} />;
      })}
    </Container>
  );
};

export default HotelsStars;
